module.exports = __webpack_public_path__ + "static/media/ic_email.0598daa9.svg";